import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

interface ITicketDetay_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ITicketDetay_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetSisyaKullaniciDetay: any[];
  GetSisyaKullaniciDetay_dummy: any[];
  SisyaKullaniciGetir: any[];
  SisyaKullaniciGetir_dummy: any[];
  GetTicketDetay: any[];
  GetTicketDetay_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
  DownloadFileFromServer: string;
  DownloadFileFromServer_dummy: string;
}

export class TicketDetay_ScreenBase extends React.PureComponent<ITicketDetay_ScreenProps, any> {
  ml = [
    {
      Id: "0140ac25-79e8-4970-bae8-db8c55d4bd78",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: []
    },
    {
      Id: "d8fdd753-5cc0-47a1-a512-86fab629667d",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 138103, PropertyName: "value", Value: "Ticket Detay" },
        {
          Id: 520093,
          PropertyName: "value",
          Value: "Ticket Detayı Görüntülenir. Dosaya indirerek detaylı inceleme yapabilirsiniz"
        },
        { Id: 935445, PropertyName: "value", Value: "Başlık :" },
        { Id: 143953, PropertyName: "value", Value: "Müşteri :" },
        { Id: 312610, PropertyName: "value", Value: "Departman :" },
        { Id: 510843, PropertyName: "value", Value: "Açıklama :" },
        { Id: 383094, PropertyName: "value", Value: "Dosya İndir :" }
      ]
    }
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetSisyaKullaniciDetay: [],
      SisyaKullaniciGetir: [],
      GetTicketDetay: [],
      GoBack: "",
      DownloadFileFromServer: ""
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("ticketdetay", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.TicketDetayPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("ticketdetay", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("ticketdetay", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.TicketDetayPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (key.startsWith("NavVisible") && prevState[key] === true && this.state[key] === false) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: []
        }
      ]);
    }
  };

  TicketDetayPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    let localVar = {
      KullaniciAdi_0: ReactSystemFunctions.convertToTypeByName(ReactSystemFunctions.getMyUsername(), "string"),
      ID_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TicketID ?? this.props.screenInputs.ticketid,
        "number"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "TicketDetay/TicketDetayPageInit", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetSisyaKullaniciDetay = result?.data.getSisyaKullaniciDetay;
    stateVars.SisyaKullaniciGetir = result?.data.sisyaKullaniciGetir;
    stateVars.GetTicketDetay = result?.data.getTicketDetay;
    formVars.ticketdetay_250222_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTicketDetay !== undefined
        ? stateVars.GetTicketDetay?.length > 0
          ? stateVars.GetTicketDetay[0].baslik
          : null
        : this.state.GetTicketDetay?.length > 0
        ? this.state.GetTicketDetay[0].baslik
        : null
    );
    formVars.ticketdetay_21635_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTicketDetay !== undefined
        ? stateVars.GetTicketDetay?.length > 0
          ? stateVars.GetTicketDetay[0].musteri
          : null
        : this.state.GetTicketDetay?.length > 0
        ? this.state.GetTicketDetay[0].musteri
        : null
    );
    formVars.ticketdetay_674102_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTicketDetay !== undefined
        ? stateVars.GetTicketDetay?.length > 0
          ? stateVars.GetTicketDetay[0].departman
          : null
        : this.state.GetTicketDetay?.length > 0
        ? this.state.GetTicketDetay[0].departman
        : null
    );
    formVars.ticketdetay_234218_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTicketDetay !== undefined
        ? stateVars.GetTicketDetay?.length > 0
          ? stateVars.GetTicketDetay[0].aciklama
          : null
        : this.state.GetTicketDetay?.length > 0
        ? this.state.GetTicketDetay[0].aciklama
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TicketDetayPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TicketDetayPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    formVars.ticketdetay_250222_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTicketDetay !== undefined
        ? stateVars.GetTicketDetay?.length > 0
          ? stateVars.GetTicketDetay[0].baslik
          : null
        : this.state.GetTicketDetay?.length > 0
        ? this.state.GetTicketDetay[0].baslik
        : null
    );

    formVars.ticketdetay_21635_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTicketDetay !== undefined
        ? stateVars.GetTicketDetay?.length > 0
          ? stateVars.GetTicketDetay[0].musteri
          : null
        : this.state.GetTicketDetay?.length > 0
        ? this.state.GetTicketDetay[0].musteri
        : null
    );

    formVars.ticketdetay_674102_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTicketDetay !== undefined
        ? stateVars.GetTicketDetay?.length > 0
          ? stateVars.GetTicketDetay[0].departman
          : null
        : this.state.GetTicketDetay?.length > 0
        ? this.state.GetTicketDetay[0].departman
        : null
    );

    formVars.ticketdetay_234218_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTicketDetay !== undefined
        ? stateVars.GetTicketDetay?.length > 0
          ? stateVars.GetTicketDetay[0].aciklama
          : null
        : this.state.GetTicketDetay?.length > 0
        ? this.state.GetTicketDetay[0].aciklama
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  TicketDetayComponent_255286_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TicketDetayComponent_965783_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DownloadFileFromServer = await ReactSystemFunctions.downloadFileFromServer(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetTicketDetay !== undefined
          ? stateVars.GetTicketDetay?.length > 0
            ? stateVars.GetTicketDetay[0].dosya
            : null
          : this.state.GetTicketDetay?.length > 0
          ? this.state.GetTicketDetay[0].dosya
          : null
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.GetTicketDetay !== undefined
          ? stateVars.GetTicketDetay?.length > 0
            ? stateVars.GetTicketDetay[0].dosyaAdi
            : null
          : this.state.GetTicketDetay?.length > 0
          ? this.state.GetTicketDetay[0].dosyaAdi
          : null
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
